import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CampaignService } from 'src/app/services/campaign.service';
import { CanComponentDeactivate } from '../guards/can-deactivate.interface';

@Component({
    selector: 'app-confirm-exit-modal.component.ts',
    templateUrl: './confirm-exit-modal.component.html',
    styleUrls: ['./confirm-exit-modal.component.scss']
})
export class ConfirmExitModalComponent {
    public message: string;
    public isVisualsWarning: boolean = false;
    /** Show the discard / save / keep-editing choice rather than the plain exit pair. */
    public offerSaveChoice: boolean = false;
    /** 'back' = returning to an earlier step; 'exit' = leaving the booking flow entirely. */
    public discardLabel: string = 'Discard and Go Back';
    public saveLabel: string = 'Save and Go Back';

    public constructor(
        private router: Router,
        private campaignService: CampaignService,
        public dialogRef: MatDialogRef<ConfirmExitModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        const visualsMessage = 'Make sure to fill the visuals details. Otherwise, your incomplete visuals will be discarded.';
        const isExiting = this.data.saveChoiceMode === 'exit';
        const unsavedVisualsMessage = isExiting
            ? 'Some visual details are incomplete or unsaved. If you exit without saving, your changes will be lost.'
            : 'Some visual details are incomplete or unsaved. If you go back without saving, your changes will be lost.';

        this.offerSaveChoice = !!this.data.offerSaveChoice;
        this.discardLabel = isExiting ? 'Discard and Exit' : 'Discard and Go Back';
        this.saveLabel = isExiting ? 'Save and Exit' : 'Save and Go Back';
        this.message = this.offerSaveChoice
            ? unsavedVisualsMessage
            : this.data.message || 'Unsaved changes will be discarded. Do you want to save before leaving?';
        this.isVisualsWarning = this.message === visualsMessage;
    }

    closeModal() {
        this.dialogRef.close(false);
    }

    closeWithoutSaving() {
        this.dialogRef.close(true);
    }

    async saveAndClose() {
        const component: CanComponentDeactivate = this.data.component;
        if (component && component.saveDraft) {
            const saved = await component.saveDraft();
            if (saved) {
                this.dialogRef.close(true);
            }
        } else {
            this.dialogRef.close(true);
        }
    }
}
